/** @jsx jsx */

import { jsx, Scalar } from "graphql-jsx";

type Props = Readonly<{
  value?: string;
  isNullable?: boolean;
}>;

export const UuidScalar = ({ value, isNullable }: Props) => <Scalar type="UUID" value={value} isNullable={isNullable} />;
